import React, {useState, useEffect} from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Aside from '../components/Aside';
import ClipLoader from "react-spinners/ClipLoader";
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import $ from 'jquery';
import 'datatables.net-dt/css/jquery.dataTables.css';
import 'datatables.net-dt/js/dataTables.dataTables';

const Products = () => {

	const [products, setProducts] = useState([])
	const [loading, setLoading] = useState(false)
    const [showForm, setShowForm] = useState(false)
    const [editing, setEditing] = useState(false)
    const [isValid, setIsValid] = useState(false)
    const [product, setProduct] = useState(null)

	useEffect(() => {
		populate()
	}, [])

     useEffect(() => {
        if (!loading && products.length > 0) {
            const table = $('#products-report').DataTable();
            return () => table.destroy(); // cleanup before re-render
        }
    }, [loading, products]);

    const handleClosePopup = () => {
		setShowForm(false);
		setEditing(false);
		setProduct(null);
	}

    const updateProduct = (e, name) => {
        const value = e.target.value;
        setProduct((state) => ({
            ...state,
            [name]: value
        }));
    }

    const handleEditProduct = (e, item) => {
        e.preventDefault();
        setProduct(item);
        setShowForm(true);
		setEditing(!!item);
    }

    const deleteProduct = (prdt_id) => {
        const endpoint = process.env.REACT_APP_BASE_URL + '/product/delete';
        fetch(endpoint, {

            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            "method": "POST",
            "body": JSON.stringify({ prdt_id })
        })
        .then(response => response.json())
        .then(response => { 
            if(response.error !== true){
                populate();
            }
        })
        .catch(err => {
            console.log(err);
            setLoading(false)
        });
    }

    const handleDeleteProduct = (e, item) => {
        e.preventDefault();
        confirmAlert({
            title: 'Delete Product',
            message: 'Are you sure to delete this item.',
            buttons: [
                {
                    label: 'Yes',
                    onClick: () => deleteProduct(item.prdt_id)
                },
                {
                    label: 'No',
                    // onClick: () => alert('Click No')
                }
            ]
        });
    }

    const saveProduct = (e) => {
        e.preventDefault()
        const endpoint = process.env.REACT_APP_BASE_URL + '/product/add/new';
        fetch(endpoint, {

            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            "method": "POST",
            "body": JSON.stringify(product)
        })
        .then(response => response.json())
        .then(response => { 
            if(response.error !== true){
                populate();
               handleClosePopup();
            }
        })
        .catch(err => {
            console.log(err);
            setLoading(false)
        });
    }

    useEffect(() => {
        const valid = product ? product.prdt_id && product.prdt_name && product.prdt_code && parseInt(product?.prdt_qte) > 0 && 
                        parseInt(product.limit_processtime) > 0 && parseInt(product.limit_storage) > 0 : false;

        setIsValid(valid);
    }, [product])

    const populate = () => {
		setLoading(true)
        const endpoint = process.env.REACT_APP_BASE_URL + '/products/all';
        fetch(endpoint, {

            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            "method": "POST",
            "body": JSON.stringify({"key_id" : process.env.REACT_APP_BASE_APIKEY})
        })
        .then(response => response.json())
        .then(response => { 
            if(response.error === true){
                setLoading(false)
            }else{
                setProducts(response.data/*.filter(item => parseInt(item.prdt_id) >= 42313485)*/)
                setLoading(false)
            }
           
        })
        .catch(err => {
            console.log(err);
            setLoading(false)
        });
    }

 	return (
  
        <div
            id="main-wrapper"
            data-layout="vertical"
            data-navbarbg="skin5"
            data-sidebartype="full"
            data-sidebar-position="absolute"
            data-header-position="absolute"
            data-boxed-layout="full"
        >
            <Header />
            <Aside page="products"/>
        
            <div className="page-wrapper">
                <div className="page-breadcrumb">
                    <div className="row">
                        <div className="col-12 d-flex no-block align-items-center">
                            <h4 className="page-title">Products</h4>
                            <div className="ms-auto flex text-end" style={{display: 'flex', gap: '30px'}}>
                                <button
                                    type="button"
                                    className="btn btn-cyan btn-sm text-white"
                                    onClick={(e) => handleEditProduct(e, null)}
                                >
                                    New Product
                                </button>
                                <nav aria-label="breadcrumb">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item"><a href="/">Home</a></li>
                                        <li className="breadcrumb-item active" aria-current="page">
                                        Products
                                        </li>
                                    </ol>
                                </nav>
                            </div>
                        </div>
                    </div>
                </div>
            
                <div className="container-fluid">
                    <div className="row">
                        <div className="card">
                            <div className="card-body">
                                <h5 className="card-title">Products</h5>
                                {
                                loading ? 
                                    <ClipLoader
                                        color="fff"
                                        loading={loading}
                                        size={10}
                                        aria-label="Loading Spinner"
                                        data-testid="loader"
                                    /> : 
                                    <div className="table-responsive">
                                        <table
                                            id="products-report"
                                            className="table table-striped table-bordered"
                                        >
                                            <thead style={{ fontWeight:'bold' }}>
                                                <tr>
                                                    <th>Id</th>
                                                    <th>Name</th>
                                                    <th>Code</th>
                                                    <th>Processing Limit (Hours)</th>
                                                    <th>Storage Limit (Gigs)</th>
                                                    <th>NB Users</th>
                                                    <th>Billing</th>
                                                    <th>Status</th>
                                                    <th></th>
                                                    <th></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    products.map((item, i) => (
                                                        <tr key={i}>
                                                            <td>{item.prdt_id}</td>
                                                            <td>{item.prdt_name}</td>
                                                            <td>{item.prdt_code}</td>
                                                            <td>{item.limit_processtime}</td>
                                                            <td>{item.limit_storage}</td>
                                                            <td>{item.prdt_qte}</td>
                                                            <td>{item.billing_cycle}</td>
                                                            {item.status === 'true' ? 
                                                                <td>Active</td>
                                                            :
                                                                <td>Inactive</td>
                                                            }
                                                            <td width={"50"}>
                                                            <a href="/#" style={{color: 'rgba(32,32,32,.75)'}} onClick={(e) => handleEditProduct(e, item)}>
                                                                    <i class="fas fa-edit"></i>
                                                                </a>
                                                            </td>
                                                            <td width={"50"}>
                                                                <a href="/#" style={{color: 'rgba(32,32,32,.75)'}} onClick={(e) => handleDeleteProduct(e, item)}>
                                                                    <i class="fas fa-trash"></i>
                                                                </a>
                                                            </td>
                                                        </tr>
                                                    ))
                                                }                            
                                            </tbody>
                                            <tfoot>
                                                <tr>
                                                    <th>Id</th>
                                                    <th>Name</th>
                                                    <th>Code</th>
                                                    <th>Processing Limit (Hours)</th>
                                                    <th>Storage Limit (Gigs)</th>
                                                    <th>NB Users</th>
                                                    <th>Billing</th>
                                                    <th>Status</th>
                                                    <th></th>
                                                    <th></th>
                                                </tr>
                                            </tfoot>
                                        </table>
                                        
                                        { showForm && (
                                            <>
                                                <div className="login-overlay overlay"></div>
                                                <div id="loginformplan" style={{ minHeight:'unset' }}>
                                                    <div className="content">
                                                        <div className="login-close" onClick={handleClosePopup}></div>
                                                        <div className="title">
                                                            <h4 className="box-title mb-3">{ editing ? 'Edit Product' : 'New Product'}</h4>
                                                        </div>
                                                    
                                                        <div className="row">
                                                            <div className="col-12">
                                                                <form>
                                                                    { !editing && (
                                                                        <>
                                                                            <div className="mb-3 form-group required">
                                                                                <label htmlFor="lastname" className="form-label">ID</label>
                                                                                <input type="text" className="form-control" id="prdt_id" name="prdt_id" value={product?.prdt_id || ''} onChange={(e) => updateProduct(e, 'prdt_id')} />
                                                                            </div>
                                                                            <div className="mb-3 form-group required">
                                                                                <label htmlFor="lastname" className="form-label">Code</label>
                                                                                <input type="text" className="form-control" id="prdt_code" name="prdt_code" value={product?.prdt_code || ''} onChange={(e) => updateProduct(e, 'prdt_code')} />
                                                                            </div>
                                                                        </>
                                                                    )}
                                                                    <div className="mb-3 form-group required">
                                                                        <label htmlFor="lastname" className="form-label">Name</label>
                                                                        <input type="text" className="form-control" id="prdt_name" name="prdt_name" value={product?.prdt_name || ''} onChange={(e) => updateProduct(e, 'prdt_name')} />
                                                                    </div>
                                                                    <div className="mb-3 form-group required">
                                                                        <label htmlFor="lastname" className="form-label">Processing Limit (Hours)</label>
                                                                        <input type="number" className="form-control" style={{width: '50%'}} id="limit_processtime" name="limit_processtime" value={product?.limit_processtime || ''} onChange={(e) => updateProduct(e, 'limit_processtime')} />
                                                                    </div>
                                                                    <div className="mb-3 form-group required">
                                                                        <label htmlFor="lastname" className="form-label">Storage Limit (Gigs)</label>
                                                                        <input type="number" className="form-control" style={{width: '50%'}} id="limit_storage" name="limit_storage" value={product?.limit_storage || ''} onChange={(e) => updateProduct(e, 'limit_storage')} />
                                                                    </div>
                                                                    <div className="mb-3 form-group required">
                                                                        <label htmlFor="lastname" className="form-label">NB Users</label>
                                                                        <input type="number" className="form-control" style={{width: '50%'}} id="prdt_qte" name="prdt_qte" value={product?.prdt_qte || ''} onChange={(e) => updateProduct(e, 'prdt_qte')} />
                                                                    </div>
                                                                    <div style={{display: 'flex', width: '100%', justifyContent: 'end'}}>
                                                                        <button type="submit" className="btn btn-primary text-medium btn-border-radius" onClick={saveProduct} disabled={!isValid}>Save</button>
                                                                    </div>
                                                                </form>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                        )}
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
  	);
}

export default Products;